export function objectToBase64(object) {
  const jsonString = JSON.stringify(object);
  return window.btoa(jsonString);
}
